import { render } from "./LEWMassnahme.vue?vue&type=template&id=63a14fa6&scoped=true&ts=true"
import script from "./LEWMassnahme.vue?vue&type=script&lang=ts"
export * from "./LEWMassnahme.vue?vue&type=script&lang=ts"

import "./LEWMassnahme.vue?vue&type=style&index=0&id=63a14fa6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a14fa6"]])

export default __exports__